// extracted by mini-css-extract-plugin
module.exports = {"button":"TextButton_button__DpWrm","icon":"TextButton_icon__Pvi4p"};